import React         from 'react';
import DocumentTitle from 'react-document-title';

// const propTypes = {
//   currentUser: React.PropTypes.object
// };

class NotFoundPage extends React.Component {
  render() {
    return (
      <DocumentTitle title="404: Not Found">
        <div>
            <h1>404</h1>
            <h3>The page you seek does not exist</h3>
        </div>
      </DocumentTitle>
    );
  }

}

// NotFoundPage.propTypes = propTypes;

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.js